import tw from 'twin.macro'

export const TableWrapper = tw.div`
  border border-solid border-default-emphasis
  rounded-md
  font-brand
  text-sm-brand
  leading-normal
  text-default-muted
`

export const TableTitle = tw.div`
  flex
  font-brand
  font-semibold
  text-sm-brand
  mb-2`

export const TableLength = tw.div`
  font-brand
  font-semibold
  text-default-muted
  ml-2
`

// todo: refactor this into an Avatar component
export const TableProfileImage = tw.img`
  rounded-full
  w-8 h-8
`

export const TableHeader = tw.div`
  py-2.5 px-4
  border-default-emphasis border-b
`

export const TableRow = tw.div`
  py-1.5
  px-4
  border-solid border-default-emphasis border-b last:border-b-0
`

export const TableTextAlt = tw.div`text-default-emphasis`

export const TableTextSmall = tw.div`text-xs-brand`

export const TableCell = tw.div`flex items-center`
